const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace('/api', '');

/**
 * Resolve an app-issued upload URL (e.g. "/uploads/cakephoto-x.png") to an absolute URL
 * for DISPLAY only. Stored/submitted values stay relative.
 */
export const resolveUploadUrl = (url?: string | null): string =>
  !url ? '' : (url.startsWith('data:') || url.startsWith('http')) ? url : `${API_ORIGIN}${url}`;
